import {
  AccountType,
  AssetType,
  AssetAccountType,
} from "@prisma/client-generated";
import { z } from "zod";

export const accountAndAssetSchemaCreate = z.object({
  description: z.string().nullish(),
  institution: z.string().nullish(), // Made optional for physical assets
  accountNumber: z.string().max(4).nullish(), // Made optional for physical assets
  currency: z.string().nullish(),
  beneficiary: z.string().nullish(),
  valueInCents: z.number().min(0),
  assetAccountType: z.nativeEnum(AssetAccountType),
  accountType: z.nativeEnum(AccountType).nullish(),
  assetType: z.nativeEnum(AssetType).nullish(),
  isJoint: z.boolean(),
  userAPercentage: z.number().int().min(0).max(100).nullish(),
  userBPercentage: z.number().int().min(0).max(100).nullish(),
});

export const accountAndAssetSchemaUpdate =
  accountAndAssetSchemaCreate.partial();

export type AccountAndAssetUpsertData = z.infer<
  typeof accountAndAssetSchemaUpdate
> & { id?: string | undefined };
